import { Injectable } from '@angular/core';
import { Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { AppSettings } from '../../../settings';
import { AuthHttp } from '../../../common';
import { TokenService } from './token.service';

@Injectable()
export class AuthenticationService {
    constructor(private http: AuthHttp) { }

    login(userId: string, password: string) {
        let loginCommand = { UserId: userId, Password: password };
        return this.http.post(AppSettings.apiEndpoint + 'Authentication/Login', loginCommand)
            .map((response: Response) => response.json());
    }

    changePassword(userId: string, newPassword: string, changeNewPassword: string) {
        let changePasswordCommand = { UserId: userId, NewPassword: newPassword, ChangeNewPassword: changeNewPassword };
        return this.http.put(AppSettings.apiEndpoint + 'Authentication/ChangePassword', changePasswordCommand)
            .map((response: Response) => response.json());
    }

    sendEmail(userId: string, email: string) {
        let sendEmailCommand = { UserId: userId, Email: email };
        return this.http.post(AppSettings.apiEndpoint + 'Authentication/SendEmail', sendEmailCommand)
            .map((response: Response) => response.json());
    }

    resetPassword(authKey: string, newPassword: string, changeNewPassword: string) {
        let resetPasswordCommand = {
            AuthKey: authKey,
            NewPassword: newPassword,
            ChangeNewPassword: changeNewPassword };
        return this.http.post(AppSettings.apiEndpoint + 'Authentication/ResetPassword', resetPasswordCommand)
            .map((response: Response) => response.json());
    }

    logout() {
        // remove user from local storage to log user out
        TokenService.removeToken();
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/security/authentication.service.ts